import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up deck-settings" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Deck Settings", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("label", {
        class: "deck-settings-label",
        for: "deck-complete-action"
      }, "When a card is checked off", -1)),
      _withDirectives(_createElementVNode("select", {
        id: "deck-complete-action",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.action) = $event))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("option", { value: "prompt" }, "Ask whether to move it", -1),
        _createElementVNode("option", { value: "none" }, "Do nothing", -1),
        _createElementVNode("option", { value: "move" }, "Move it to a column", -1)
      ]))], 512), [
        [_vModelSelect, _ctx.action]
      ]),
      (_ctx.action == 'move')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              class: "deck-settings-label",
              for: "deck-complete-column"
            }, "Column", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "deck-complete-column",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.column) = $event))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "Pick a column", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (name) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: name,
                  value: name
                }, _toDisplayString(name), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.column]
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: "Save",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
      }, null, 2)
    ])
  ]))
}